import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-your-property',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './your-property.component.html',
  styleUrl: './your-property.component.scss',
})
export class YourPropertyComponent {
  @Input() title!: string;
  @Input() description!: string;
  @Input() buttonText!: string;

  @Input() showArrows: boolean = true;
  @Input() customClass: string = '';

  @Output() buttonClick = new EventEmitter<any>();

  onButtonClick(): void {
    this.buttonClick.emit();
  }
}
